import type {
  UserPreferences,
  UserPreferencesUpdateInput,
} from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const preferencesApi = {
  get() {
    return request<UserPreferences>("/admin/me/preferences");
  },
  update(input: UserPreferencesUpdateInput) {
    return request<UserPreferences>("/admin/me/preferences", {
      method: "PATCH",
      body: input,
    });
  },
};
